const STAGE_MESSAGES = {
  edit_render:
    'The edited image could not be rendered. Your original attachment is still available.',
  encryption: 'The attachment could not be encrypted on this device.',
  local_storage: 'Device storage is full. Keep the app open while the attachments upload.',
  multipart_start: 'The secure upload could not be started.',
  storage_upload:
    'The secure storage upload was blocked or the network connection was interrupted.',
  multipart_complete: 'The attachment reached storage but could not be finalized.',
  message_delivery: 'The attachments uploaded, but the encrypted message could not be delivered.',
};

export const createMessengerV2AttachmentError = (stage, cause = null) => {
  const error = new Error(STAGE_MESSAGES[stage] || 'The attachment could not be sent.');
  error.name = 'MessengerV2AttachmentError';
  error.code = `ATTACHMENT_${String(stage || 'unknown').toUpperCase()}`;
  error.stage = stage || 'unknown';
  error.status = cause?.status ?? null;
  error.cause = cause || null;
  return error;
};

export const normalizeMessengerV2AttachmentError = (error, fallbackStage = 'storage_upload') => {
  if (error?.name === 'AbortError' || error?.name === 'MessengerV2AttachmentError') return error;
  if (error?.code === 'ATTACHMENT_QUEUE_WRITE_FAILED') {
    return createMessengerV2AttachmentError('local_storage', error);
  }
  return createMessengerV2AttachmentError(fallbackStage, error);
};

export const resolveMessengerV2AttachmentErrorTranslationKey = (error) => {
  switch (error?.stage) {
    case 'edit_render':
      return 'messenger_v2.attachment.edit_render_failed';
    case 'encryption':
      return 'messenger_v2.attachment.encryption_failed';
    case 'local_storage':
      return 'messenger_v2.attachment.storage_warning';
    case 'storage_upload':
    case 'multipart_start':
    case 'multipart_complete':
      return 'messenger_v2.attachment.upload_failed';
    default:
      return 'messenger_v2.attachment.send_failed';
  }
};
